import React, { PureComponent } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { Icon } from "@formant/ui/component/common/Icon";

import { formatTime } from "../../utils/formatTime";
import * as styles from "./Timestamp.scss";

export interface ITimestampProps {
    time: Date;
    className?: string;
}

@observer
export class Timestamp extends PureComponent<ITimestampProps> {
    public render() {
        const { time, className } = this.props;
        return (
            <div className={classnames(styles.timestamp, className)}>
                <Icon name="clock" />
                <div>{formatTime(time)}</div>
            </div>
        );
    }
}
